/* @flow */
import Money from './Money.jsx';
import React from 'react';
import Text from 'components/Text.jsx';
import Transaction from 'entities/Transaction';
import Tooltip from 'components/Tooltip.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Timestamp from 'components/Timestamp.jsx';

type Props = {
  transaction: Transaction,
};

const TransactionAmount = (props: Props) => {
  const { transaction } = props;

  let prefix = null;
  let sufix = null;
  let color = null;

  if (transaction.isWithdrawal()) {
    prefix = 'Deposited';
  }

  if (transaction.isRefundSent()) {
    prefix = 'Refunded';
    color = 'lava';
  }

  if (transaction.isPaymentSent()) {
    prefix = 'Paid';
    color = 'lava';
  }

  if (transaction.isPaymentReceived()) {
    prefix = 'Received';
    color = 'jungle';

    if (transaction.getRefundedTransactionUUID()) {
      sufix = '(refunded)';
    }
  }

  if (transaction.isPending()) {
    sufix = '(pending)';
    color = 'koala';
  }

  const amount = (
    <Text {...props} color={color}>
      {prefix} <Money cents={transaction.getAmount()} /> {sufix}
    </Text>
  );

  if (transaction.isPending() && transaction.getAvailableAt()) {
    const tooltipText = new Date().toDateString() === transaction.getAvailableAt().toDateString() ?
      'Transaction will be completed' :
      'Transaction will be completed on';

    const tooltip = (
      <Tooltip>
        <Text weight="light">
          {tooltipText}{' '}
          <Timestamp date={transaction.getAvailableAt()} />
        </Text>
      </Tooltip>
    );

    return (
      <LayerTrigger layer={tooltip} trigger="hover" placement="bottom">
        <span> {/* for LayerTrigger to add on onClick */}
          {amount}
        </span>
      </LayerTrigger>
    );
  }

  return amount;
};

export default TransactionAmount;



// WEBPACK FOOTER //
// ./src/payments/components/TransactionAmount.jsx